<template>
  <div class="page">

    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->


    <h2 class="myTitle hidden-sm-and-down" style="margin-bottom: 0;">Anmeldung</h2>

    <!--        <v-container>-->
    <!--            <div class="text-center">-->
    <!--                <h2 data-gtranslate="express">AN erforderlich</h2>-->
    <!--                <h4 data-gtranslate="express_sub">Ein eigener Account ist völlig kostenlos!</h4>-->
    <!--            </div>-->
    <!--        </v-container>-->

    <div class="spacer-15"></div>
    <div class="spacer-15 hidden-md-and-up"></div>

    <!--        <div class="loading" v-if="loading">-->
    <!--            <div>Loading...</div>-->
    <!--            <div><img src="../assets/icons/loader.gif"></div>-->
    <!--        </div>-->


    <div class="uiWrapper">
      <div class="loader"><img src="../assets/icons/loader.gif"></div>
      <div id="firebaseui-auth-container"></div>
    </div>


    <!--        <div class="text-center">-->
    <!--            <img style="width: 200px; height: auto" src="../assets/icons/firebase_knockout.png">-->
    <!--        </div>-->


    <div class="spacer-25"></div>

    <div class="spacer-25"></div>
    <div class="text-center">
      <!--            <h3>Neuen Account erstellen?</h3>-->
      <v-btn
        @click.native.passive="gotoResetPW"
        class="text-none btn-df">Passwort vergessen?
      </v-btn>
    </div>

    <div class="spacer-25"></div>
    <div class="text-center">
      <!--            <h3>Neuen Account erstellen?</h3>-->
      <v-btn
        @click.native.passive="gotoRegister"
        class="btn-df">
        <v-icon left medium>mdi-account-plus</v-icon>
        Registrieren
      </v-btn>
    </div>

    <div class="spacer-25"></div>

    <!--        <div class="text-center">-->
    <!--            <v-btn style="margin-top: 25px" onclick="window.history.back()">-->
    <!--                Später erinnern-->
    <!--            </v-btn>-->
    <!--        </div>-->


    <!--            <div class="iframe-container">-->
    <!--                <iframe sandbox="allow-forms allow-same-origin allow-scripts allow-modals allow-popups"-->
    <!--                        frameborder="0"-->
    <!--                        :src="signinPage" class="xFrame">-->
    <!--                </iframe>-->
    <!--            </div>-->

  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as util from '@/vendor/util'
// import * as bootstrap from '../vendor/bootstrap'
// import {jumpToTop} from "@/vendor/util";
import * as firebaseUtil from '../firebase/firebaseUtil'

export default {
  components: {
    // CenterTitle
  },
  data() {
    return {
      wasAlreadyloggedIn: false,
    }
  },
  created() {
    ebus.$on('signinReturn', () => {

      if (this.wasAlreadyloggedIn) {
        ebus.$emit('userSignedIn');
      }

      //     //remove the query parameter "mode"
      //     window.history.replaceState({}, document.title, '/restaurant/' + bootstrap.slug + '/#/signin');
      //
      //     //https://forum.vuejs.org/t/how-to-remove-one-query-string-from-url/39176
      //     // let query = Object.assign({}, this.$route.query);
      //     // delete query.mode;
      //     // does not work:
      //     // this.$router.replace({ path: store.state.currentRoute, query: {} });
      //
      //     this.$router.replace({name: 'home'});
    });
  },
  // mounted() {
  //     //only called the first time
  // },
  destroyed() {
    util.clearEvents([
      'appconfigLoaded',
    ]);
  },
  mounted() {
    // store.commit('currentRoute', 'signin');
    store.commit('showLoading', false);
    this.wasAlreadyloggedIn = !!store.getters.loggedIn;

    firebaseUtil.initRecaptcha(() => {
    });

    store.commit('loginPostprocessing', true);
    console.log('???signin activated');
    firebaseUtil.initFirebaseUi();
    // jumpToTop();
  },
  methods: {

    gotoRegister() {
      this.$router.push({name: 'Registrierung'});
    },

    gotoResetPW() {
      this.$router.push({name: 'resetPassword'});
    }

  }
}
</script>
<style lang="scss" scoped>
/*@import '../styles/sharedStyles';*/

.uiWrapper {
  position: relative;
  min-height: 50px;

  .loader {
    position: absolute;
    top: 15px;
    left: 0;
    width: 100%;
    height: 50px;
    text-align: center;

    img {
      width: 40px;
      height: auto;
    }
  }
}

.loading {
  text-align: center;

  div {
    margin: 15px;
  }
}

/*.iframe-container {*/
/*    position: relative;*/
/*}*/

/*.xFrame {*/
/*    height: calc(100vh - 56px);//height of the AppHeader*/
/*    width: 100%;*/
/*    border: none;*/

/*    position: absolute;*/
/*    top: 0;*/
/*}*/
</style>
